import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  createUrlTreeFromSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable, map } from 'rxjs';
import { PermissionService } from '../../services/permission/permission.service';
import { UserService } from '../../services/user/user.service';
import { environment } from '@env/environment';
@Injectable({
  providedIn: 'root',
})
export class PermissionGuard implements CanActivate {
  constructor(
    private permissionService: PermissionService,
    private router: Router,
    private userService: UserService
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree | any {
    return new Observable<boolean | UrlTree>((observer) => {
      this.permissionService.userRoles
        .pipe(
          map((roles) => {
            if (
              this.permissionService.checkPermission(route.data['roles'], roles)
            ) {
              observer.next(true);
              observer.complete();
            } else {
              this.userService
                .getUserProfile()
                .pipe()
                .subscribe(() => {
                  this.permissionService.userRoles
                    .pipe(
                      map((roles) => {
                        if (
                          this.permissionService.checkPermission(
                            route.data['roles'],
                            roles
                          )
                        ) {
                          observer.next(true);
                          observer.complete();
                        } else {
                          window.location.href = environment.ADMIN_HUB_URL + '/login?returnUrl='+ encodeURIComponent(window.location.href);
                          observer.next(
                          false
                          );
                          observer.complete();
                        }
                      })
                    )
                    .subscribe();
                });
            }
          })
        )
        .subscribe();
    });
  }
}

// return window.location.href = environment.ADMIN_HUB_URL + '/login?r='+ encodeURIComponent(window.location.href);